module.exports = __webpack_public_path__ + "img/EA200_1-1.c2da0eb7.jpg";